import { render, staticRenderFns } from "./stock-in.vue?vue&type=template&id=39fdde9e&"
import script from "./stock-in.vue?vue&type=script&lang=js&"
export * from "./stock-in.vue?vue&type=script&lang=js&"
import style0 from "./stock-in.vue?vue&type=style&index=0&id=39fdde9e&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39fdde9e')) {
      api.createRecord('39fdde9e', component.options)
    } else {
      api.reload('39fdde9e', component.options)
    }
    module.hot.accept("./stock-in.vue?vue&type=template&id=39fdde9e&", function () {
      api.rerender('39fdde9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warehouses/stock-in.vue"
export default component.exports